import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
import {
  navItemIdSchema,
  navStructureSurfaceSchema,
} from '../../models/nav-service';

export type {
  NavStructureItem,
  NavStructureSurface,
} from '../../models/nav-service';

const sidebarStructure = defineMessage({
  type: 'sidebar-structure' as const,
  payloadSchema: t.object({ sidebarStructure: navStructureSurfaceSchema }),
});

const getSidebarStructure = defineMessage({
  type: 'get-sidebar-structure' as const,
  payloadSchema: t.object({ source: t.string }),
  reply: sidebarStructure,
});

const sidebarMutationResultSchema = t.union(
  t.object({ success: t.literal(true) }),
  t.object({ success: t.literal(false), reason: t.literal('UNSUPPORTED') }),
  t.object({
    success: t.literal(false),
    reason: t.literal('FAILED'),
    failureReason: t.string,
  })
);

const sidebarMutationResult = defineMessage({
  type: 'sidebar-mutation-result' as const,
  payloadSchema: sidebarMutationResultSchema,
});

const toggleItem = defineMessage({
  type: 'toggle-sidebar-item' as const,
  payloadSchema: t.object({
    source: t.string,
    navItemId: navItemIdSchema,
  }),
  reply: sidebarMutationResult,
});

export const sidebarApi = {
  getSidebarStructure,
  sidebarStructure,
  toggleItem,
  sidebarMutationResult,
} as const;
